import { type AriaAttributes, type JSX } from 'react';

import { type DefaultSizes } from '@depop/web-thrift-ui/Icons/types';

export enum TrackingType {
  about = 'homepage_getstarted_cta',
  buyer = 'homepage_shopnow_cta',
  seller = 'homepage_sellondepop_cta',
  banner = 'homepage_banner_shopnow_cta',
  skinnyBanner = 'homepage_skinny_banner_shopnow_cta',
  compactBanner = 'homepage_compact_banner_sellnow_cta',
  meganav = 'meganav',
}

export type ShopByPriceTileType = {
  id?: string;
  price: string;
  title: string;
  link: string;
  backgroundStyle: string;
};

export type IconComponent = (
  props: { size: DefaultSizes } & AriaAttributes
) => JSX.Element;

export type PropositionConfig = {
  icon: IconComponent;
  titleKey: string;
  descriptionKey: string;
  href?: string;
};

export type HomepageHeroContent = {
  title: string;
  subtext: string;
  mobileImageUrl: string;
  desktopImageUrl: string;
  imageAltText: string;
};

export type DualPropositionHeroContent = {
  buy: HomepageHeroContent;
  sell: HomepageHeroContent;
};
